<div class="globalrules-container">
    <div class="banner">
        <div class="title">
            <fa-icon [icon]="faAngleRight"></fa-icon>
            <span>{{ 'GlobalRules.Title' | translate }}</span>
        </div>

        @if (!isReadOnly) {
        <div class="action-zone">
            <button color="accent" mat-button routerLink="/globalrule">
                {{ 'GlobalRules.ButtonRuleCreation' | translate }}
                <mat-icon>add_circle</mat-icon>
            </button>
        </div>
        }
    </div>

    <div class="table-container" [ngClass]="!isReadOnly ? 'table-container' : 'table-container-readonly'">
        <form class="filters-form" [formGroup]="filtersForm">
            <div class="mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort>
                    <!--
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>
              <span mat-sort-header>{{'GlobalRules.ColumnHeaderId'|translate}}</span>
              <mat-form-field>
                <input matInput formControlName="id" (keyup)="applyFilters()" autocomplete="off"/>
                <button mat-icon-button matSuffix class="header-button" matTooltip="{{ 'GlobalRules.ResetFilterColumn' | translate }}"
                  (click)="resetColumnFilter('id')" type="button">
                  <mat-icon>undo</mat-icon>
                </button>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let element"> {{element.id}} </td>
          </ng-container> -->

                    <ng-container matColumnDef="enabled">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'GlobalRules.ColumnHeaderEnabled' | translate }}</span>
                            <div class="checkbox-header">
                                <mat-checkbox
                                    color="accent"
                                    formControlName="enabled"
                                    [indeterminate]="checkBoxStatus === null"
                                    [checked]="checkBoxStatus"
                                    (change)="checkBoxChange()"></mat-checkbox>
                                <button
                                    mat-icon-button
                                    matSuffix
                                    class="mat-accent search-icon"
                                    matTooltip="{{ 'RulesByExtensions.ResetFilterColumn' | translate }}"
                                    (click)="resetColumnFilter('enabled')">
                                    <mat-icon>undo</mat-icon>
                                </button>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-checkbox [checked]="element.enabled" disabled></mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="ringState">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'GlobalRules.ColumnHeaderRingState' | translate }}</span>
                            <div class="small">
                                <mat-form-field class="form-field" appearance="outline">
                                    <mat-select formControlName="ringState" (selectionChange)="applyFilters()" multiple>
                                        @for (state of ringStates; track state) {
                                        <mat-option [value]="state">
                                            {{ 'EnumRingStates.' + state | translate }}
                                        </mat-option>
                                        }
                                    </mat-select>
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'GlobalRules.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('ringState')">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ 'EnumRingStates.' + element.ringState | translate }}</td>
                    </ng-container>

                    <ng-container matColumnDef="targetType">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'GlobalRules.ColumnHeaderTargetType' | translate }}</span>
                            <div class="small">
                                <mat-form-field class="form-field" appearance="outline">
                                    <mat-select formControlName="targetType" (selectionChange)="applyFilters()" multiple>
                                        @for (target of targetTypes; track target) {
                                        <mat-option [value]="target">
                                            {{ 'EnumRuleTargetTypes.' + target | translate }}
                                        </mat-option>
                                        }
                                    </mat-select>
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'GlobalRules.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('targetType')">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ 'EnumRuleTargetTypes.' + element.targetType | translate }}</td>
                    </ng-container>

                    <ng-container matColumnDef="ringSeconds">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'GlobalRules.ColumnHeadeRingSecond' | translate }}</span>
                            <div class="small">
                                <mat-form-field class="form-field" appearance="outline">
                                    <input matInput formControlName="ringSeconds" (keyup)="applyFilters()" autocomplete="off" />
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'RulesByExtensions.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('ringSeconds')">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.ringSeconds }}</td>
                    </ng-container>

                    <ng-container matColumnDef="target">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'GlobalRules.ColumnHeadeTarget' | translate }}</span>
                            <div class="small">
                                <mat-form-field class="form-field" appearance="outline">
                                    <input matInput formControlName="target" (keyup)="applyFilters()" autocomplete="off" />
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'RulesByExtensions.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('target')">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.targetDisplay }}</td>
                    </ng-container>

                    <ng-container matColumnDef="actions" stickyEnd>
                        <th mat-header-cell *matHeaderCellDef>
                            <button
                                mat-icon-button
                                matSuffix
                                class="header-button"
                                matTooltip="{{ 'GlobalRules.ResetAllFiltersColumn' | translate }}"
                                (click)="resetAllColumnFilter()">
                                <mat-icon>undo</mat-icon>
                            </button>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-column">
                                <button mat-icon-button routerLink="/globalrule" [queryParams]="{ id: element.id }">
                                    <mat-icon>visibility</mat-icon>
                                </button>
                                <button mat-icon-button (click)="onDeleteClick(element.id)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>

                <mat-paginator [pageSizeOptions]="[25, 50, 100]" class="default-paginator"></mat-paginator>
            </div>
        </form>
    </div>
</div>
